import React, { useRef } from 'react'
import DialogWrapper from './DialogWrapper'
import Button from './Button'
export default function ResetPassword( { resetPassword, closePasswordReset } ) {

    const inputRef = useRef()

    return (
        <DialogWrapper
            id='password-reset'
        >
            <p className='font-bold'>Enter the email associated with your account and submit. You will receive an email with a password reset link.</p>
            <label
                htmlFor="email"
                className="flex flex-col items-start gap-4 my-4 font-bold"
            >   
                Email:
                <input
                    ref={inputRef}
                    className="border-2 border-slate-500 h-10 rounded-md pl-2 w-full text-slate-600 focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500"
                    type="email"
                    id="email"
                    required
                />
            </label>
            <Button
                color='green'
                clickFunction={() => {
                    resetPassword(inputRef.current.value)
                }}
            >
                Recover Password
            </Button>
            <Button
                color='gray'
                clickFunction={closePasswordReset}
            >
                Cancel
            </Button>
        </DialogWrapper>
    )
}
